import { render, staticRenderFns } from "./semantic-card.component.vue?vue&type=template&id=23e81171&scoped=true"
import script from "./semantic-card.component.vue?vue&type=script&lang=ts"
export * from "./semantic-card.component.vue?vue&type=script&lang=ts"
import style0 from "./semantic-card.component.vue?vue&type=style&index=0&id=23e81171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e81171",
  null
  
)

export default component.exports